export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.companyId = item != null ? item.companyId : ''
        this.name = item != null ? item.name : ''
        this.tag = item != null ? item.tag : ''
        this.coupling = item != null ? item.coupling : null
        this.mailUsername = item != null ? item.mailUsername : ''
        this.mailIsActive = item != null ? item.mailIsActive : false
        this.modules = item != null ? item.modules : ''
    }
}